// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"804":"e63b3212","840":"51a699fe"}[chunkId] + ".chunk.js";
};